"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Styled = __importStar(require("./CircularProgressStyles"));
var react_feather_1 = require("react-feather");
var CircularProgress = function (_a) {
    var className = _a.className, progress = _a.progress, _b = _a.radius, radius = _b === void 0 ? 28 : _b, _c = _a.stroke, stroke = _c === void 0 ? 6 : _c, label = _a.label, showCheck = _a.showCheck, showLabelCentered = _a.showLabelCentered, color = _a.color, _d = _a.error, error = _d === void 0 ? false : _d, props = __rest(_a, ["className", "progress", "radius", "stroke", "label", "showCheck", "showLabelCentered", "color", "error"]);
    var normalizedRadius = radius - stroke * 2;
    var circumference = normalizedRadius * 2 * Math.PI;
    var strokeDashoffset = error
        ? 0
        : circumference - (progress / 100) * circumference;
    return (React.createElement(Styled.Container, null,
        React.createElement(Styled.Svg, { radius: radius },
            React.createElement(Styled.Rail, { strokeWidth: stroke, normalizedRadius: normalizedRadius, radius: radius, color: color }),
            React.createElement(Styled.Track, { strokeWidth: stroke, normalizedRadius: normalizedRadius, radius: radius, circumference: circumference, strokeDashoffset: strokeDashoffset, color: color, error: error })),
        error && (React.createElement(Styled.CheckContainer, { radius: radius }, "!")),
        showCheck && progress === 100 && !error && (React.createElement(Styled.CheckContainer, { radius: radius },
            React.createElement(react_feather_1.Check, { color: "var(--blue)", size: radius - stroke }))),
        label && showLabelCentered ? (!(showCheck && progress === 100) ? (React.createElement(Styled.CenteredLabelContainer, { radius: radius },
            React.createElement(Styled.Label, { color: color }, label))) : null) : (React.createElement(Styled.Label, { color: color }, label))));
};
exports.default = CircularProgress;
